import { render, staticRenderFns } from "./SupportProfile.vue?vue&type=template&id=74716956&scoped=true"
import script from "./SupportProfile.vue?vue&type=script&lang=js"
export * from "./SupportProfile.vue?vue&type=script&lang=js"
import style0 from "./SupportProfile.vue?vue&type=style&index=0&id=74716956&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74716956",
  null
  
)

export default component.exports